/* Koshnika — Buy now → GoKwik checkout (sticky bar + in-page button)

   WHY THIS EXISTS
   GoKwik's snippet scans every button on the page and, when the label contains
   "buy now", swaps it for a clone with type="button" and takes over the click.
   That silently cancelled the theme's own KrBuyNow form submit and left the
   sticky button depending on GoKwik's onBuyNowClick, which does nothing when
   the SDK is not ready — a dead button.

   Both Buy now buttons now carry data-gokwik-processed="true" in the markup, so
   that scanner skips them, and this file runs the flow explicitly:

     1. Set this saree to quantity 1 in the cart. Never doubles a line that is
        already there; anything else in the cart is kept.
     2. Wait for the GoKwik SDK, up to 10 s. Polls as well as listening,
        because 'gokwikLoaded' fires once and is not re-sent to a listener
        that registers after it.
     3. gokwikSdk.initCheckout(merchantInfo) — the same call GoKwik's own cart
        Checkout button makes.

   FAILURE MODES
   • SDK never arrives: the button reads "Try again". It does NOT fall through
     to native checkout, which has no COD.
   • This file fails to load: the buttons are still type="submit" on the
     KrBuyNow form, so a tap opens Shopify checkout. Slower path, never dead.
*/
(function () {
  if (window.krGkBuyReady) return;
  window.krGkBuyReady = true;

  var SDK_WAIT_MS = 10000;
  var COOLDOWN_MS = 2500;
  var busy = false;

  function getSdk() {
    return window.gokwikSdk || window.__gkSdkCache || null;
  }

  function whenSdk(ms) {
    return new Promise(function (resolve) {
      var found = getSdk();
      if (found) { resolve(found); return; }

      var settled = false;
      var poll;
      var timer;

      function finish(value) {
        if (settled) return;
        settled = true;
        window.removeEventListener('gokwikLoaded', onLoaded);
        clearInterval(poll);
        clearTimeout(timer);
        resolve(value);
      }
      function onLoaded() {
        var s = getSdk();
        if (s) finish(s);
      }

      window.addEventListener('gokwikLoaded', onLoaded);
      poll = setInterval(onLoaded, 200);
      timer = setTimeout(function () { finish(null); }, ms);
    });
  }

  function productForm(btn) {
    var pf = btn.closest('product-form-component');
    if (pf) return pf;
    /* The sticky bar sits outside the product form; find the form by product id */
    var sticky = btn.closest('sticky-add-to-cart') || document.querySelector('sticky-add-to-cart[data-product-id]');
    if (!sticky) return null;
    return document.querySelector(
      'product-form-component[data-product-id="' + sticky.getAttribute('data-product-id') + '"]'
    );
  }

  function variantId(btn, pf) {
    var input = pf && pf.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    var sticky = btn.closest('sticky-add-to-cart');
    return sticky ? sticky.getAttribute('data-current-variant-id') : null;
  }

  function setState(text, isBusy) {
    var all = document.querySelectorAll('[data-kr-gk-buy]');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      if (isBusy) b.setAttribute('aria-busy', 'true');
      else b.removeAttribute('aria-busy');
      var l = b.querySelector('[data-kr-label]');
      if (l) l.textContent = text;
    }
  }

  function reset() {
    busy = false;
    setState('Buy now', false);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-kr-gk-buy]') : null;
    if (!btn) return;

    var pf = productForm(btn);
    var vid = variantId(btn, pf);

    /* No variant means nothing to open GoKwik for. Leave the click alone so the
       native form submit runs. */
    if (!vid) return;

    e.preventDefault();

    var add = pf && pf.querySelector('[ref="addToCartButton"]');
    if (busy || btn.disabled || (add && add.disabled)) return;

    busy = true;
    setState('Opening checkout\u2026', true);

    var updates = {};
    updates[vid] = 1;

    var setLine = fetch(btn.getAttribute('data-kr-cart-update') || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });

    Promise.all([setLine, whenSdk(SDK_WAIT_MS)]).then(function (res) {
      var cart = res[0];
      var sdk = res[1];
      if (!sdk || !window.merchantInfo) throw new Error('sdk');
      /* GoKwik's snippet rendered window.cart at page load; keep it current */
      window.cart = cart;
      sdk.initCheckout(window.merchantInfo);
      setTimeout(reset, COOLDOWN_MS);
    }).catch(function () {
      busy = false;
      setState('Try again', false);
    });
  });

  /* Back from a checkout page via the browser's back-forward cache */
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) reset();
  });
})();
